"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BinarySchema = void 0;
const schema_1 = require("../schema");
const schema_type_1 = require("../schema-type");
class BinarySchema extends schema_1.Schema {
    constructor(description, objectInitializer) {
        super("binary", description, schema_type_1.SchemaType.Binary);
        this.apply(objectInitializer);
    }
}
exports.BinarySchema = BinarySchema;
//# sourceMappingURL=binary.js.map